module.exports = __webpack_public_path__ + "img/mobile/Prompts-gameintro/animated@3x.png?1.0.24";


//////////////////
// WEBPACK FOOTER
// ./out/img/mobile/Prompts-gameintro/animated@3x.png
// module id = 730
// module chunks = 0